module.exports = __webpack_public_path__ + "static/media/R-ranking.7a870f64.svg";